import { Box, Mark, TextInput } from "@mantine/core";
import { useState } from "react";

interface DeleteSiteModalBodyElementProps {
  siteName: string;
  onVerificationTextChange: (isCorrect: boolean) => void;
}

function DeleteSiteModalBodyElement({
  siteName,
  onVerificationTextChange
}: DeleteSiteModalBodyElementProps) {
  const [value, setValue] = useState("");

  function handleChange(event: React.ChangeEvent<HTMLInputElement>) {
    setValue(event.target.value);
    onVerificationTextChange(event.target.value === siteName);
  }

  return (
    <div className="DeleteSiteModalBodyElement">
      <p>
        Sind Sie sicher, dass Sie diese Liegenschaft löschen möchten? Dieser
        Schritt kann nicht rückgängig gemacht werden.
      </p>
      <Box>
        Geben Sie zur Bestätigung den Namen der Liegenschaft{" "}
        <Mark>{siteName}</Mark> in das Textfeld ein.
        <TextInput value={value} onChange={handleChange} />
      </Box>
    </div>
  );
}

export { DeleteSiteModalBodyElement };
